// @ts-nocheck
import { CHECK_PACKAGE_VERSION_ERROR, CHECK_PACKAGE_VERSION_LOADING, CHECK_PACKAGE_VERSION_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const CheckPackageVersionReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_PACKAGE_VERSION_LOADING:
            return Object.assign({}, state, { loading: true })
        case CHECK_PACKAGE_VERSION_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CHECK_PACKAGE_VERSION_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

